//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'EditionBlock',
  props: {
    title: {
      type: String,
      required: true
    },
    headingColour: {
      type: String,
      default: 'is-accent'
    },
    isShow: {
      type: Boolean,
      default: true
    },
    hasShadow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardClass() {
      const classes = []

      if (!this.hasShadow) classes.push('is-shadowless')

      return classes.join(' ')
    }
  }
}
